import React from 'react';
import TourBookingForm from './TourBookingForm';
import { useSiteContent, sectionField } from '../../hooks/useSiteContent';
import { getImageUrl } from '../../utils/imageUrl';

function BookATour() {
  const { content } = useSiteContent('contact');
  const title = sectionField(content, 'booking', 'title', 'Book Your Tour Slot');
  const bgImage =
    getImageUrl(sectionField(content, 'booking', 'bg_image', '')) ||
    '/assets/img/bg/video_bg_1.jpg';

  return (
    <div
      className="space-extra2-top space-extra2-bottom twa-contact-booking"
      style={{
        '--twa-booking-image': `url("${bgImage}")`,
        backgroundImage: `url("${bgImage}")`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        backgroundPosition: 'center center',
      }}
    >
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-8">
            <div className="twa-booking-panel">
              <TourBookingForm title={title} source="contact_page" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default BookATour;
